import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';

import {
  edit_affiliate_settings_path,
  edit_topics_settings_path,
  edit_user_email_settings_path,
  edit_user_team_settings_path,
  group_subscriptions_settings_path,
  user_dashboard_path,
} from '@routes';

import styles from './styles.module.scss';

const SETTING_NAV_OPTIONS = [
  { path: user_dashboard_path, label: 'Account', access: false },
  { path: edit_affiliate_settings_path, label: 'Referral', access: false },
  { path: edit_topics_settings_path, label: 'Topics', access: false },
  { path: edit_user_email_settings_path, label: 'Email preferences', access: false },
  { path: group_subscriptions_settings_path, label: 'Gift subscriptions', access: false },
  { path: edit_user_team_settings_path, label: 'Team subscriptions', access: false },
];

const activeItemNav = () => {
  return {
    borderColor: '#f32a52',
    color: '#f32a52',
  };
};

const NavContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentActiveItem = SETTING_NAV_OPTIONS.find(
    (option) => option.path() === location.pathname
  );

  return (
    <>
      <div className={styles.settingsHeaderContainer}>
        <h1 className={styles.settingsHeader}>Settings</h1>
        <div className={styles.settingNavMobile}>
          <Select
            options={SETTING_NAV_OPTIONS}
            onChange={(e) => navigate(e.path())}
            value={currentActiveItem}
            getOptionValue={(navSettings) => navSettings.label}
            isSearchable={false}
          />
        </div>
      </div>
      <div className={styles.settingsNavContainer}>
        <div className="border-0 border-l-4 border-solid border-grayscale-beige">
          {SETTING_NAV_OPTIONS.map((option) => (
            <NavLink
              key={option.label}
              end
              to={option.path()}
              className={styles.navItem}
              style={(isActive) => (isActive.isActive ? activeItemNav() : undefined)}
            >
              {option.label}
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
};

export default NavContent;
